import { SxProps } from "@mui/material";

export interface CustomStyles {
  flexCenter: SxProps;
  flexBetween: SxProps;
  flexStart: SxProps;
  flexEnd: SxProps;
  columnCenter: SxProps;
  columnBetween: SxProps;
  columnStart: SxProps;
  ellipsisOneLine: SxProps;
  ellipsisFourLines: SxProps;
  link: SxProps;
  ellipsisTwoLine: SxProps;
  disabled: SxProps;
}

export type CustomStyleVariable = { [key: string]: SxProps };

export const customStyles: CustomStyles = {
  disabled: {
    opacity: 0.3,
    pointerEvents: "none",
  },
  ellipsisOneLine: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "1",
    WebkitBoxOrient: "vertical",
    whiteSpace: "pre-wrap",
  },
  ellipsisTwoLine: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    whiteSpace: "pre-wrap",
  },
  ellipsisFourLines: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "4",
    WebkitBoxOrient: "vertical",
    whiteSpace: "pre-wrap",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexStart: {
    display: "flex",
    alignItems: "center",
  },
  flexEnd: {
    display: "felx",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  columnCenter: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
  },
  columnBetween: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  columnStart: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  link: {
    color: "#1A73E8",
    borderBottom: `1px solid #1A73E8`,
    lineHeight: "18px",
    cursor: "pointer",
    fontWeight: "300",
  },
};
